<script lang="ts">
  import { settingsStore } from "../lib/stores/settings";

  $: template = $settingsStore.template as Record<string, string>;
</script>

<div class="w-full flex justify-end">
  <section
    class="h-full bg-cover bg-center rounded-4xl hidden lg:block aspect-[1300/1550]"
    role="img"
    aria-label={template?.backgroundImgAlt}
    style={`background-image: url("${template?.backgroundImg}"); height: 100%`}>
  </section>

  <section
    class="w-full h-full bg-cover bg-center rounded-2xl block lg:hidden aspect-[1000/700]"
    role="img"
    aria-label={template?.backgroundImgAlt}
    style={`background-image: url("${template?.mobileBackgroundImg}"); height: 100%`}>
  </section>
</div>
